import * as React from "react";
const SvgPause = () => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M8.404.75H6.217c-.743 0-1.346.603-1.346 1.346v19.291c0 .744.603 1.346 1.346 1.346h2.187c.744 0 1.346-.602 1.346-1.346V2.097C9.75 1.352 9.148.75 8.404.75M17.784.75h-2.187c-.744 0-1.347.603-1.347 1.346v19.291c0 .743.603 1.346 1.347 1.346h2.187c.743 0 1.346-.603 1.346-1.346V2.096c0-.743-.603-1.346-1.346-1.346"
  }
));
export default SvgPause;
